(function () {
    let toggle = document.getElementById("contacts-toggle");
    let overlay = document.getElementById("contacts-overlay");

    if (toggle && overlay) {
        toggle.addEventListener("click", function () {
            if (overlay.style.display === "none") {
                overlay.style.display = "block";
                document.body.classList.add("no-scroll-mobile");
            } else {
                overlay.style.display = "none";
                document.body.classList.remove("no-scroll-mobile");
            }
        });
    }
})();
